import {
  OPEN_ANNUAL_REVIEW_REPORT,
  CLOSE_ANNUAL_REVIEW_REPORT,
  SET_ANNUAL_REVIEW_REPORT_DATA,
  SET_ANNUAL_REVIEW_REPORT_LOADING,
  SET_ANNUAL_REVIEW_REPORT_DATE_RANGE,
  SET_CLIENT_TYPE,
} from '../actions';
import { SIGN_OUT_USER } from '../../../actions/auth';
import { getDefaultPeriodRange } from '../periodUtils';

const initialState = {
  isModalOpen: false,
  isLoading: false,
  selectedHubId: null,
  data: null,
  dateRange: getDefaultPeriodRange(),
  clientType: null,
  error: null,
};

const getClosedState = () => ({
  ...initialState,
  dateRange: getDefaultPeriodRange(),
});

const annualReviewReportReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case OPEN_ANNUAL_REVIEW_REPORT:
      return {
        ...state,
        isModalOpen: true,
        selectedHubId: data?.hubId ?? null,
        data: null,
        dateRange: getDefaultPeriodRange(),
        clientType: null,
        error: null,
      };
    case CLOSE_ANNUAL_REVIEW_REPORT:
    case SIGN_OUT_USER:
      return getClosedState();
    case SET_ANNUAL_REVIEW_REPORT_DATA:
      return {
        ...state,
        data,
        clientType: data?.accountSnapshot?.clientType ?? null,
        error: null,
      };
    case SET_ANNUAL_REVIEW_REPORT_LOADING:
      return {
        ...state,
        isLoading: data,
      };
    case SET_ANNUAL_REVIEW_REPORT_DATE_RANGE:
      return {
        ...state,
        dateRange: data?.dateRange ?? state.dateRange,
      };
    case SET_CLIENT_TYPE:
      return {
        ...state,
        clientType: data?.clientType ?? null,
      };
    default:
      return state;
  }
};

export default annualReviewReportReducer;
